// extracted by mini-css-extract-plugin
export default {"overlay":"AB-z","bodyOpen":"BB-z","content":"CB-z","header":"DB-z","closeNoHeading":"EB-z"};